export default __webpack_public_path__ + "static/media/midasi_entry_vi_sp.1f19be44.png";